module.exports = __webpack_public_path__ + "static/img/logo.649a8607.svg";